import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled from 'styled-components';
import CloseStyles from './Close/Close.styles';
const Container = styled(m.div) `
  --bgColor: transparent;
  --fgColor: ${brand.white};
  --tintColor: rgba(0, 0, 0, 0.7);
  --buttonSize: ${fluid(36, 44)};
  --gutter: 75px;

  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  color: var(--fgColor);
  height: 100%;
  place-content: center;
  place-items: center;
  width: 100%;
  z-index: ${Layers.Modal};

  &[data-open='false'] {
    display: none;
  }

  ${CloseStyles.Button} {
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
    --bgColorHover: ${brand.beige};
  }
`;
const Inner = styled(m.div) `
  --gutterAmount: calc(var(--buttonSize) * 2 + 16px);
  --maxHeight: calc(100dvh - var(--gutterAmount));

  position: relative;
  max-width: calc(100dvw - 48px);
  max-height: var(--maxHeight);

  @media ${from(Device.TabletLarge)} {
    --gutterAmount: var(--gutter) * 2;

    margin: var(--gutter) 0;
    max-width: calc(100dvw - var(--gutterAmount));

    > video,
    > img {
      max-height: calc(100vh - var(--gutterAmount));
      max-width: calc(100vw - var(--gutterAmount));
    }
  }
`;
const ModalStyles = {
    Container,
    Inner,
};
export default ModalStyles;
